import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  Table,
  Button,
  Modal,
  Breadcrumb,
  Switch,
  Icon,
} from "antd";


import Footer from "../../components/Footer/Footer";
import classes from "./SettingsLanguages.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { listLanguages, updateLanguage } from "../../api/requests";
import { logout, updateUser } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import SettingsLanguageForm from "./SettingsLanguageForm";

const { Content } = Layout;

class SettingsLanguages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      languagesList: [],
      errorMessage: "",
      responseMessage: "",
      languageModalVisible: false,
      editLanguage: null,
    };
  }

  async componentDidMount() {
    this.getLanguagesList();
  }

  getLanguagesList = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await listLanguages();

      this.props.updateUser({
        languages: data.filter((item) => item.active),
      });

      this.setState({ languagesList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({ errorMessage: get(e, "response.data.error", "Error") });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const {
      languagesList,
      errorMessage,
      responseMessage,
      isLoading,
    } = this.state;

    let columns = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Language"),
        render: (val, record) => record.name,
      },
      {
        dataIndex: "code",
        key: "code",
        title: this.props.i18n.t("Code"),
        render: (val, record) => record.code,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Active"),
        render: (val, record) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              type="edit"
              theme="filled"
              className={classes.actionIcon}
              style={
                record.code === "en"
                  ? { opacity: 0.5, cursor: "not-allowed" }
                  : { opacity: 1, cursor: "pointer" }
              }
              onClick={() => {
                if (record.code !== "en") {
                  this.setState({
                    languageModalVisible: true,
                    editLanguage: record,
                  });
                }
              }}
            />
            <Switch
              disabled={record.code === "en"}
              checked={record.active}
              onChange={async () => {
                await updateLanguage({ id: record.id, active: !record.active });

                const languages = languagesList.map((item) =>
                  item.id === record.id
                    ? { ...item, active: !record.active }
                    : item
                );

                this.props.updateUser({
                  languages: languages.filter((item) => item.active),
                });

                this.setState({
                  languagesList: languages,
                });
              }}
            />
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Languages")}
            </h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("Languages")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <div>
              <Button
                type="primary"
                onClick={() => this.setState({ languageModalVisible: true })}
                loading={isLoading}
                disabled={isLoading}
              >
                {this.props.i18n.t("NamespaceSettingsLanguages:Add language")}
              </Button>
              <br />
              <br />
            </div>

            <Table
              columns={columns}
              dataSource={languagesList}
              loading={isLoading}
              pagination={false}
              rowKey="id"
            />

            <Modal
              visible={this.state.languageModalVisible}
              onCancel={() =>
                this.setState({
                  languageModalVisible: false,
                  editLanguage: null,
                })
              }
              footer={null}
            >
              {this.state.languageModalVisible && (
                <SettingsLanguageForm
                  language={this.state.editLanguage}
                  languages={languagesList}
                  onSubmit={() =>
                    this.setState(
                      { languageModalVisible: false },
                      this.getLanguagesList
                    )
                  }
                  onCancel={() =>
                    this.setState({
                      languageModalVisible: false,
                      editLanguage: null,
                    })
                  }
                />
              )}
            </Modal>
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout, updateUser };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsLanguages))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsLanguages/SettingsLanguages.js